module.exports = __webpack_public_path__ + "img/bg-camera-tablet-v2.846e8c8f.png";